import React, { useMemo } from "react";
import "./QualityCheckReport.scss";
import { BlobProvider } from "@react-pdf/renderer";
import QAReport from "../../reports/QuoteReport/QAReport";
import { useSelector } from "react-redux";
import { userDetails } from "../../redux/user/userSelector";
import { CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import { SkuQualityDetailSchema } from "../../models/SkuQualityDetail";

interface QualityCheckReportProps {
  qualityCheckDetail: SkuQualityDetailSchema;
}

const QualityCheckReport: React.FC<QualityCheckReportProps> = ({
  qualityCheckDetail,
}) => {
  const currentUser = useSelector(userDetails);

  const memoizedDocument = useMemo(() => {
    const today = dayjs().format("DD-MM-YY");
    return (
      <QAReport
        user={currentUser}
        currentDate={today}
        qualityCheckDetail={qualityCheckDetail}
      />
    );
  }, [qualityCheckDetail]);

  const handleOpenQuotationPdf = (url: string, filename: string) => {
    window.open(url, "_blank");
  };

  return (
    <BlobProvider document={memoizedDocument}>
      {({ blob, url, loading, error }) => {
        if (loading) return <CircularProgress size={20} />;
        if (error) {
          console.error("ERROR PDF", error);
          return (
            <button className="report-download-button" disabled>
              Error generating PDF
            </button>
          );
        }
        const filename = `QAReport.pdf`;
        return (
          <div
            className="download-report-container p-8 cursor-pointer"
            onClick={() => handleOpenQuotationPdf(url || "", filename)}
          >
            <img
              height={12}
              width={12}
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240904094334-download_purple.svg"
              alt="download"
            />
          </div>
        );
      }}
    </BlobProvider>
  );
};

export default QualityCheckReport;
